module.exports = __webpack_public_path__ + "img/media_20240408_224931_5506463999809934640.5891c143.jpg";